<template lang="pug">
  v-app
    router-view
    Footer
</template>

<script>
import Footer from "@/views/home/Footer";

export default {
  watch: {
    ["$route"]() {
      window.scrollTo(0, 0);
    }
  },
  components: {
    Footer
  },
  data() {
    return {
      location: null,
      gettingLocation: false,
      errorStr: null
    };
  },
  created() {
    //do we support geolocation
    if (!("geolocation" in navigator)) {
      this.errorStr = "Geolocation is not available.";
      return;
    }

    this.gettingLocation = true;
    // get position
    navigator.geolocation.getCurrentPosition(
      pos => {
        this.gettingLocation = false;
        this.location = pos;

        this.$store.commit("customer/updateLocation", {
          latitude: this.location.coords.latitude,
          longitude: this.location.coords.longitude
        });
      },
      err => {
        this.gettingLocation = false;
        this.errorStr = err.message;
      }
    );
  }
};
</script>
